// export const apiRoute = "http://192.168.29.65:8009/api";
// export const apiRoute = "http://127.0.0.1:8002/api";
// export const apiRoute = "http://127.0.0.1:8000/api";
// export const apiRoute = "http://riddhijain.xyz/public/api";
// export const apiRoute = "https://vgmdining.co.in/public/api";
export const apiRoute = "http://npssolutions.in/apis/public/api";